// extracted by mini-css-extract-plugin
var _1 = "gGrdbqeoziBPw7EDKe12";
var _2 = "gGrdbqeoziBPw7EDKe12";
var _3 = "KPTXBmeWXPti47vPNMpc";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "title" }
